export default "__VITE_ASSET__CHZU9jzW__"